import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=ed2f0cf8&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed2f0cf8')) {
      api.createRecord('ed2f0cf8', component.options)
    } else {
      api.reload('ed2f0cf8', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=ed2f0cf8&", function () {
      api.rerender('ed2f0cf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2C6swR9VoxwtM/JS/offershelp.vue"
export default component.exports